/* eslint-disable no-lonely-if */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import $ from 'jquery';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import _t from './translate';
import checkMetamask from './checkMetamask';
import showAlert from './showAlert';
import claimTokenRequest from './claimTokenRequest';
// import claimDgcTokenRequest from './claimDgcTokenRequest';
import login from './checkLogin';

const claimTokens = async () => {
  const marketplaceElements = $('.js-claim-tokens');
  if (!marketplaceElements.length) {
    return;
  }

  console.log('marketplaceElements', marketplaceElements);

  marketplaceElements.off('click.claimToken').on('click.claimToken', async (e) => {
    if (!await login()) {
      return;
    }

    const isVerified = $(e.currentTarget).data('is-verified');
    if (!isVerified) {
      Swal.fire({
        title: _t('E-mail Verification'),
        html: `
          <div class="" style="margin-bottom: 20px; margin-bottom: 20px; padding-left: 50px">
            <div class="d-flex align-items-center">
              <input style="width: 20px" type="checkbox" id="check_1" />&nbsp;<label for="check_1">I read and agree with the <a style="color:#000" target="_blank" href="/terms-and-conditions">"Terms and Conditions"</a></label> <br />
            </div>
            <div class="d-flex align-items-center">
              <input style="width: 20px" type="checkbox" id="check_2" />&nbsp;<label for="check_2">I read and agree with the <a style="color:#000" target="_blank" href="/prohibition-of-use">"Prohibition of USE"</a></label><br />
            </div>
            <div class="d-flex align-items-center">
              <input style="width: 20px" type="checkbox" id="check_3" />&nbsp;<label for="check_3">I read and agree with the <a style="color:#000" target="_blank" href="/explicit-consent-declaration">"GDPR and PDPL"</a></label><br />
            </div>
          </div>
          Enter your e-mail:
          `,
        input: 'email',
        inputAttributes: {
          autocapitalize: 'off',
        },
        customClass: {
          popup: 'sw-long',
          cancelButton: 'order-1',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        },
        inputValidator(inputValue) {
          if (!$('#check_1').is(':checked')) {
            return 'Please approve Terms and Conditions';
          }
          if (!$('#check_2').is(':checked')) {
            return 'Please approve Prohibition of USE';
          }
          if (!$('#check_3').is(':checked')) {
            return 'Please approve GDPR and PDPL';
          }
          if (!inputValue) {
            return 'Please enter your email';
          }
        },
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: _t('Confirm'),
        showLoaderOnConfirm: true,
        preConfirm: async (value) => {
          const accounts = await web3Client.eth.getAccounts();
          const address = accounts[0];
          const email = value;

          const msgData = {
            email,
            address,
            chainId: window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId,
            sessionKey: window.sessionKey,
          };

          $.post({
            url: '/api/wallet/sendVerificationEmail',
            headers: {
              token: window.token,
            },
            data: msgData,
            success: (data) => {
              if (data.success) {
                Swal.fire({
                  html: `
                    <div class="" styl="margin-top: 30px; font-size: 22px;">
                      ${_t('Please enter your verification code. ')}
                    </div>
                    <div class="" style="margin-top: 10px;">
                      Please enter your verification code. Please note that, by entering your code you confirm the conditions
                    </div>
                  `,
                  input: 'text',
                  inputAttributes: {
                    autocapitalize: 'off',
                  },
                  customClass: {
                    popup: 'sw-long',
                    cancelButton: 'order-1',
                    confirmButton: 'order-2',
                    denyButton: 'order-3',
                  },
                  showCloseButton: true,
                  showCancelButton: true,
                  confirmButtonText: _t('Confirm'),
                  showLoaderOnConfirm: true,
                  preConfirm: async (val) => {
                    const accountsData = await web3Client.eth.getAccounts();
                    const addressData = accountsData[0];

                    $.post('/api/wallet/verifyEmail', `email=${email}&address=${addressData}&code=${val}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}`, async (response) => {
                      if (response.success) {
                        await Swal.fire(
                          _t('Success!'),
                          _t('Successfully verified your email, you can now refresh the page and retry the transfer'),
                          'success',
                        );

                        document.location.reload(true);
                      } else {
                        Swal.fire(
                          _t('Error!'),
                          response.message,
                          'error',
                        );
                      }
                    });
                  },
                  allowOutsideClick: () => !Swal.isLoading(),
                });
              }
            },
            error(xhr, status, error) {
              // handle error
            },
          });
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });

      return;
    }

    Swal.fire({
      html: `<p style="margin-top: 50px;">${_t('How much $NFSG token you want to transfer?')}</p>`,
      title: 'Withdraw',
      input: 'number',
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (value) => {
        if (!await checkMetamask()) {
          return;
        }

        const accounts = await web3Client.eth.getAccounts();
        console.log('accounts', accounts);
        const address = accounts[0];
        if (value < 1) {
          showAlert(_t('Minimum tranfer amount is %s NFSG').replace('%s', '1'), 'error');
        } else {
          claimTokenRequest(address, value, 0);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }
    });
  });
};

export default claimTokens;
